import { pgTable, uuid, timestamp, varchar, index, boolean } from 'drizzle-orm/pg-core';
import { users } from '../../user/models/users';
import { paymentMethodTypeEnum } from '../enums/paymentMethodTypeEnum';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  user_id: uuid('user_id').notNull().references(() => users.id),
  payment_method_type: paymentMethodTypeEnum('payment_method_type').notNull(),
  account_holder_name: varchar('account_holder_name', { length: 64 }).notNull(),
  last_four_digits: varchar('last_four_digits', { length: 4 }).notNull(),
  bank_name: varchar('bank_name', { length: 64 }),
  is_default: boolean('is_default').$defaultFn(() => false).notNull(),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  date_modified: timestamp('date_modified', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  // Paystack integration fields
  /** Paystack customer code for identifying the customer */
  paystack_customer_code: varchar('paystack_customer_code', { length: 64 }),
  /** Paystack authorization code for payment method authorization */
  paystack_authorization_code: varchar('paystack_authorization_code', { length: 128 }),
  /** Bank Identification Number (BIN) from Paystack */
  paystack_bin: varchar('paystack_bin', { length: 10 }),
  /** Card type from Paystack (e.g., Visa, Mastercard) */
  paystack_card_type: varchar('paystack_card_type', { length: 32 }),
  /** Bank name from Paystack */
  paystack_bank: varchar('paystack_bank', { length: 64 }),
};

/**
 * @internal
 */
export const patientPaymentMethods = pgTable(
  'PatientPaymentMethods', 
  schema,
  (table) => [
    index('patient_payment_method_external_id_idx').on(table.external_id),
    index('patient_payment_method_user_id_idx').on(table.user_id),
    index('patient_payment_method_type_idx').on(table.payment_method_type),
    index('patient_payment_method_default_idx').on(table.is_default),
    // Paystack indexes for performance optimization
    index('idx_paystack_customer_code').on(table.paystack_customer_code),
    index('idx_paystack_authorization_code').on(table.paystack_authorization_code),
  ]
);
